export default __webpack_public_path__ + "static/adminstrar_polizas-7aa8f6f9b2dcdfb1cdd6728a5c0bc34e.mp4";